// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticlesItemTags-module__articleTags--NBy04{line-height:20px}.ArticlesItemTags-module__showMore--VspeY{font-size:11px;font-weight:600;margin-left:2px;padding:0}.ArticlesItemTags-module__articleTag--D4KQ_{display:inline;font-size:11px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"articleTags": `ArticlesItemTags-module__articleTags--NBy04`,
	"showMore": `ArticlesItemTags-module__showMore--VspeY`,
	"articleTag": `ArticlesItemTags-module__articleTag--D4KQ_`
};
export default ___CSS_LOADER_EXPORT___;
